var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hades-tooltip-wrap"},[_c('div',{on:{"mouseover":_vm.overContent}},[_vm._t("tootip-hover")],2),_c('div',{class:_vm.tooltipClasses,style:(_vm.tooltipStyles)},[_vm._t("tooltip-content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }